(function () {
  if (customElements.get('easy-quote-order-modal')) return;

  class EasyQuoteOrderModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;

      // マークアップ側では open を付けていないため、この時点で開いていれば
      // 最前面レイヤーから外れた居残り状態（ページ内に見えてしまう）
      if (this.dialog.open) this.dialog.close();

      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onDialogClick = this.onDialogClick.bind(this);
      this.onDialogClose = this.onDialogClose.bind(this);

      document.addEventListener('click', this.onDocumentClick);
      this.dialog.addEventListener('click', this.onDialogClick);
      this.dialog.addEventListener('close', this.onDialogClose);

      this.watchCartDrawer();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      if (this.dialog) {
        this.dialog.removeEventListener('click', this.onDialogClick);
        this.dialog.removeEventListener('close', this.onDialogClose);
      }
      if (this.cartDrawerObserver) this.cartDrawerObserver.disconnect();
      this.unlockPageScroll();
    }

    // ダイアログは最前面レイヤーに出るため、開いたままではカートドロワーが隠れて見えない
    watchCartDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || !window.MutationObserver) return;

      var self = this;
      this.cartDrawerObserver = new MutationObserver(function () {
        if (drawer.classList.contains('active')) self.close();
      });
      this.cartDrawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    onDocumentClick(event) {
      var openTrigger = event.target.closest('[data-eqo-quote-open]');
      if (openTrigger) {
        event.preventDefault();
        this.open();
        return;
      }

      var closeTrigger = event.target.closest('[data-eqo-quote-close]');
      if (closeTrigger && this.contains(closeTrigger)) {
        event.preventDefault();
        this.close();
      }
    }

    onDialogClick(event) {
      if (event.target === this.dialog) this.close();
    }

    onDialogClose() {
      this.unlockPageScroll();
    }

    lockPageScroll() {
      document.body.classList.add('overflow-hidden');
      document.documentElement.style.overflow = '';
    }

    unlockPageScroll() {
      document.body.classList.remove('overflow-hidden');
      document.documentElement.style.overflow = '';
    }

    open() {
      if (!this.dialog || this.dialog.open) return;
      this.dialog.showModal();

      // 既定では最初の操作要素（閉じるボタン）にフォーカスが入り、フォーカス枠が出てしまう
      var body = this.dialog.querySelector('.eqo-modal__body');
      if (body) body.focus({ preventScroll: true });

      this.lockPageScroll();
    }

    close() {
      if (!this.dialog || !this.dialog.open) return;
      this.unlockPageScroll();
      this.dialog.close();
    }
  }

  customElements.define('easy-quote-order-modal', EasyQuoteOrderModal);
})();
